import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IClient } from '../../../../interfaces/ElementModels/IClient';

const ClientBox = ({ clientData }) => {
  const client = useMemo<IClient>(() => clientData, [clientData]);
  const encodedClient = encodeURIComponent(client.ClientID);

  return (
    <Box className="clientBox">
      <h2>{client.ClientID}</h2>
      <p>{client.FullAddress}</p>
      <Link to={`/pricelists/${encodedClient}`}>
        <VisibilityIcon /> View
      </Link>
    </Box>
  );
};

export default ClientBox;
